import * as $runtime from "../runtime.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dPrelude$dSpecularExtra from "../Restaumatic.Prelude.SpecularExtra/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dDom$dWidgets$dInput from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const textInputOnChange = /* #__PURE__ */ Specular$dDom$dWidgets$dInput.textInputOnChange(/* #__PURE__ */ (() => {
  const $0 = Specular$dDom$dBuilder.monoidBuilder(Data$dMonoid.monoidUnit);
  return {
    MonadDomBuilder0: () => Specular$dDom$dBuilder.monadDomBuilderBuilder,
    MonadFRP1: () => ({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder}),
    MonadReplace2: () => Specular$dDom$dBuilder.monadReplaceBuilder,
    Monoid3: () => $0
  };
})());
const subscribeEvent_ = /* #__PURE__ */ Specular$dFRP$dBase.subscribeNode(Specular$dInternal$dRIO.monadEffectRIO)(Specular$dDom$dBuilder.monadCleanupBuilder);
const counterView = count => updateCount => Specular$dDom$dElement.el("div")([Specular$dDom$dElement.class_("numeric-stepper")])((() => {
  const increase = updateCount(count + 1 | 0);
  return Specular$dInternal$dRIO.bindImpl((() => {
    const $0 = updateCount(count - 1 | 0);
    return Specular$dDom$dElement.el("a")([
      Specular$dDom$dElement.class_("decrement"),
      Specular$dDom$dElement.attr("href")("#"),
      Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(v => $0)
    ])(Specular$dDom$dElement.text("-"));
  })())(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(Specular$dFRP$dBase.changed)(textInputOnChange(Data$dShow.showIntImpl(count))(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = {};
    $0.maxlength = "2";
    return $0;
  })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = {};
    $0.size = "2";
    return $0;
  })())(Foreign$dObject.unionWith(Data$dSemigroup.concatString)((() => {
    const $0 = {};
    $0.type = "number";
    return $0;
  })())((() => {
    const $0 = Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.order_summary.quantity), {});
    return (() => {
      const $1 = {};
      $1.title = $0;
      return $1;
    })();
  })()))))))(newValueString => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("a")([
    Specular$dDom$dElement.class_("increment"),
    Specular$dDom$dElement.attr("href")("#"),
    Restaumatic$dPrelude$dSpecularExtra.onClickPreventDefault_(v => increase)
  ])(Specular$dDom$dElement.text("+")))(() => subscribeEvent_(updateCount)(Specular$dFRP$dBase.filterMapEvent(a => {
    const $0 = Data$dInt.fromString(a);
    if ($0.tag === "Just") {
      if ($0._1 >= 0) { return Data$dMaybe.$Maybe("Just", $0._1); }
      return Data$dMaybe.Nothing;
    }
    if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
    $runtime.fail();
  })(newValueString)))));
})());
export {counterView, subscribeEvent_, textInputOnChange};
